import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import platform from 'platform';
var isBrowser = typeof window !== 'undefined';
/**
 * Validates options and sets defaults for undefined properties.
 * @param {?Object} opts
 * @returns {Object} opts - Validated options.
 */

var validate = function validate() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Create new object to avoid changes by reference
  var _opts = {}; // Defaults to false

  _opts.detailed = opts.detailed === true; // Defaults to true

  _opts.ignoreLocalhost = opts.ignoreLocalhost !== false; // Defaults to true

  _opts.ignoreOwnVisits = opts.ignoreOwnVisits !== false;
  return _opts;
};
/**
 * Determines if a host is a localhost.
 * @param {String} hostname - Hostname that should be tested.
 * @returns {Boolean} isLocalhost
 */


var isLocalhost = function isLocalhost(hostname) {
  return hostname === '' || hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
};
/**
 * Determines if user agent is a bot. Approach is to get most bots, assuming other bots don't run JS.
 * Source: https://stackoverflow.com/questions/20084513/detect-search-crawlers-via-javascript/20084661
 * @param {String} userAgent - User agent that should be tested.
 * @returns {Boolean} isBot
 */


var isBot = function isBot(userAgent) {
  return /bot|crawler|spider|crawling/i.test(userAgent);
};
/**
 * Checks if an id is a fake id. This is the case when Ackee ignores you because of the `ackee_ignore` cookie.
 * @param {String} id - Id that should be tested.
 * @returns {Boolean} isFakeId
 */


var isFakeId = function isFakeId(id) {
  return id === '88888888-8888-8888-8888-888888888888';
};
/**
 * Checks if the website is in background (e.g. user has minimzed or switched tabs).
 * @returns {boolean}
 */


var isInBackground = function isInBackground() {
  return document.visibilityState === 'hidden';
};
/**
 * Get the optional source parameter.
 * @returns {String} source
 */


var source = function source() {
  var source = (location.search.split("source=")[1] || '').split('&')[0];
  return source === '' ? undefined : source;
};
/**
 * Gathers all platform-, screen- and user-related information.
 * @param {Boolean} detailed - Include personal data.
 * @returns {Object} attributes - User-related information.
 */


export var attributes = function attributes() {
  var detailed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var defaultData = {
    siteLocation: window.location.href,
    siteReferrer: document.referrer,
    source: source()
  };
  var detailedData = {
    siteLanguage: (navigator.language || navigator.userLanguage).substr(0, 2),
    screenWidth: screen.width,
    screenHeight: screen.height,
    screenColorDepth: screen.colorDepth,
    deviceName: platform.product,
    deviceManufacturer: platform.manufacturer,
    osName: platform.os.family,
    osVersion: platform.os.version,
    browserName: platform.name,
    browserVersion: platform.version,
    browserWidth: window.outerWidth,
    browserHeight: window.outerHeight
  };
  return _objectSpread(_objectSpread({}, defaultData), detailed === true ? detailedData : {});
};
/**
 * Creates an object with a query and variables property to create a record on the server.
 * @param {String} domainId - Id of the domain.
 * @param {Object} input - Data that should be transferred to the server.
 * @returns {Object} Create record body.
 */

var createRecordBody = function createRecordBody(domainId, input) {
  return {
    query: "\n\t\t\tmutation createRecord($domainId: ID!, $input: CreateRecordInput!) {\n\t\t\t\tcreateRecord(domainId: $domainId, input: $input) {\n\t\t\t\t\tpayload {\n\t\t\t\t\t\tid\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t",
    variables: {
      domainId: domainId,
      input: input
    }
  };
};
/**
 * Creates an object with a query and variables property to update a record on the server.
 * @param {String} recordId - Id of the record.
 * @returns {Object} Update record body.
 */


var updateRecordBody = function updateRecordBody(recordId) {
  return {
    query: "\n\t\t\tmutation updateRecord($recordId: ID!) {\n\t\t\t\tupdateRecord(id: $recordId) {\n\t\t\t\t\tsuccess\n\t\t\t\t}\n\t\t\t}\n\t\t",
    variables: {
      recordId: recordId
    }
  };
};
/**
 * Creates an object with a query and variables property to create an action on the server.
 * @param {String} eventId - Id of the event.
 * @param {Object} input - Data that should be transferred to the server.
 * @returns {Object} Create action body.
 */


var createActionBody = function createActionBody(eventId, input) {
  return {
    query: "\n\t\t\tmutation createAction($eventId: ID!, $input: CreateActionInput!) {\n\t\t\t\tcreateAction(eventId: $eventId, input: $input) {\n\t\t\t\t\tpayload {\n\t\t\t\t\t\tid\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t",
    variables: {
      eventId: eventId,
      input: input
    }
  };
};
/**
 * Creates an object with a query and variables property to update an action on the server.
 * @param {String} actionId - Id of the action.
 * @param {Object} input - Data that should be transferred to the server.
 * @returns {Object} Update action body.
 */


var updateActionBody = function updateActionBody(actionId, input) {
  return {
    query: "\n\t\t\tmutation updateAction($actionId: ID!, $input: UpdateActionInput!) {\n\t\t\t\tupdateAction(id: $actionId, input: $input) {\n\t\t\t\t\tsuccess\n\t\t\t\t}\n\t\t\t}\n\t\t",
    variables: {
      actionId: actionId,
      input: input
    }
  };
};
/**
 * Construct URL to the GraphQL endpoint of Ackee.
 * @param {String} server - URL of the Ackee server.
 * @returns {String} endpoint - URL to the GraphQL endpoint of the Ackee server.
 */


var endpoint = function endpoint(server) {
  var hasTrailingSlash = server.substr(-1) === '/';
  return server + (hasTrailingSlash === true ? '' : '/') + 'api';
};
/**
 * Sends a request to a specified URL.
 * Won't catch all errors as some are already logged by the browser.
 * In this case the callback won't fire.
 * @param {String} url - URL to the GraphQL endpoint of the Ackee server.
 * @param {Object} body - JSON which will be send to the server.
 * @param {Object} opts - Options.
 * @param {?Function} next - The callback that handles the response. Receives the following properties: json.
 */


var send = function send(url, body, opts, next) {
  var xhr = new XMLHttpRequest();
  xhr.open('POST', url);

  xhr.onload = function () {
    if (xhr.status !== 200) {
      throw new Error('Server returned with an unhandled status');
    }

    var json = null;

    try {
      json = JSON.parse(xhr.responseText);
    } catch (e) {
      throw new Error('Failed to parse response from server');
    }

    if (json.errors != null) {
      throw new Error(json.errors[0].message);
    }

    if (typeof next === 'function') {
      return next(json);
    }
  };

  xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
  xhr.withCredentials = opts.ignoreOwnVisits;
  xhr.send(JSON.stringify(body));
};
/**
 * Looks for an element with Ackee attributes and executes Ackee with the given attributes.
 * Fails silently.
 */


export var detect = function detect() {
  var elem = document.querySelector('[data-ackee-domain-id]');
  if (elem == null) return;
  var server = elem.getAttribute('data-ackee-server') || '';
  var domainId = elem.getAttribute('data-ackee-domain-id');
  var opts = elem.getAttribute('data-ackee-opts') || '{}';
  create(server, JSON.parse(opts)).record(domainId);
};
/**
 * Creates a new instance.
 * @param {String} server - URL of the Ackee server.
 * @param {?Object} opts
 * @returns {Object} instance
 */

export var create = function create(server, opts) {
  opts = validate(opts);
  var url = endpoint(server);

  var noop = function noop() {}; // Fake instance when Ackee ignores you


  var fakeInstance = {
    record: function record() {
      return {
        stop: noop
      };
    },
    updateRecord: function updateRecord() {
      return {
        stop: noop
      };
    },
    action: noop,
    updateAction: noop
  };

  if (opts.ignoreLocalhost === true && isLocalhost(location.hostname) === true) {
    console.warn('Ackee ignores you because you are on localhost');
    return fakeInstance;
  }

  if (isBot(navigator.userAgent) === true) {
    console.warn('Ackee ignores you because you are a bot');
    return fakeInstance;
  } // Creates a new record on the server and updates the record
  // very x seconds to track the duration of the visit. Tries to use
  // the default attributes when there're no custom attributes defined.


  var _record = function _record(domainId) {
    var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : attributes(opts.detailed);
    var next = arguments.length > 2 ? arguments[2] : undefined;
    // Function to stop updating the record
    var isStopped = false;

    var stop = function stop() {
      isStopped = true;
    };

    send(url, createRecordBody(domainId, attrs), opts, function (json) {
      var recordId = json.data.createRecord.payload.id;

      if (isFakeId(recordId) === true) {
        return console.warn('Ackee ignores you because this is your own site');
      }

      var interval = setInterval(function () {
        if (isStopped === true) {
          clearInterval(interval);
          return;
        }

        if (isInBackground() === true) return;
        send(url, updateRecordBody(recordId), opts);
      }, 15000);

      if (typeof next === 'function') {
        return next(recordId);
      }
    });
    return {
      stop: stop
    };
  }; // Updates a record very x seconds to track the duration of the visit


  var _updateRecord = function _updateRecord(recordId) {
    // Function to stop updating the record
    var isStopped = false;

    var stop = function stop() {
      isStopped = true;
    };

    if (isFakeId(recordId) === true) {
      console.warn('Ackee ignores you because this is your own site');
      return {
        stop: stop
      };
    }

    var interval = setInterval(function () {
      if (isStopped === true) {
        clearInterval(interval);
        return;
      }

      if (isInBackground() === true) return;
      send(url, updateRecordBody(recordId), opts);
    }, 15000);
    return {
      stop: stop
    };
  }; // Creates a new action on the server


  var _action = function _action(eventId, attrs, next) {
    send(url, createActionBody(eventId, attrs), opts, function (json) {
      var actionId = json.data.createAction.payload.id;

      if (isFakeId(actionId) === true) {
        return console.warn('Ackee ignores you because this is your own site');
      }

      if (typeof next === 'function') {
        return next(actionId);
      }
    });
  }; // Updates an action


  var _updateAction = function _updateAction(actionId, attrs) {
    if (isFakeId(actionId) === true) {
      return console.warn('Ackee ignores you because this is your own site');
    }

    send(url, updateActionBody(actionId, attrs), opts);
  }; // Return the real instance


  return {
    record: _record,
    updateRecord: _updateRecord,
    action: _action,
    updateAction: _updateAction
  };
}; // Only run Ackee automatically when executed in a browser environment

if (isBrowser === true) {
  detect();
}